import { jsx } from 'react/jsx-runtime';
import { ResourceDataContext } from './resourceDataContext.js';
import { getResourceNamePlaceholder } from '../../../resources/utils/getResourceTitle.js';
import { isResourceDetailAudio, isResourceDetailFolder, isResourceDetailVideo, isResourceDetailNotepad, isResourceDetailImage, isResourceDetailBookmark, isResourceDetailHighlight } from '../../../resources/utils/resourceDetailGuards.js';
import React__default from 'react';
import useDocumentPreviewable from '../../hooks/useDocumentPreviewable.js';
import { useQueryUserInfo } from '../../../user/queries/useQueryUserInfo.js';
import { useDownloadResource } from '../../../resources/hooks/useDownloadResource.js';
import { isTruthy } from '@fabric-app/utils/guards';
import { useResourcePermissionsByCurrentUser } from './getDisabledActionsReasons.js';
import { PermissionRole } from '@fabric/woody-client';
import { getWillRegisterSubdocumentSearch } from '../../../search/utils/getWillRegisterSubdocumentSearch.js';

const ResourceDataContextProvider = ({ resource, children, parentColorLabels }) => {
  const { data: user } = useQueryUserInfo();
  const handleDownload = useDownloadResource(resource);
  const { disabledActions, permissions } = useResourcePermissionsByCurrentUser(resource);
  const isPreviewable = useDocumentPreviewable(resource);
  const providedValue = React__default.useMemo(() => {
    return {
      resource,
      permissions,
      readOnly: !resource ? true : !user || resource.root?.type === "INTEGRATION" || !!disabledActions.modify,
      handleDownload,
      fullName: [
        resource?.name,
        resource?.extension
      ].filter(isTruthy).join("."),
      placeholderName: resource ? getResourceNamePlaceholder(resource) : "Untitled",
      parentColorLabels,
      disabledActions,
      userRole: resource?.permission?.role || PermissionRole.VIEWER,
      isRenameable: resource ? isResourceDetailAudio(resource) || isResourceDetailAudio(resource) || isPreviewable || isResourceDetailFolder(resource) || isResourceDetailVideo(resource) || isResourceDetailNotepad(resource) || isResourceDetailImage(resource) || isResourceDetailBookmark(resource) || isResourceDetailHighlight(resource) : false,
      willRegisterSubdocumentSearch: resource ? getWillRegisterSubdocumentSearch(resource) : false
    };
  }, [
    resource,
    permissions,
    user,
    disabledActions,
    handleDownload,
    parentColorLabels,
    isPreviewable
  ]);
  return /* @__PURE__ */ jsx(ResourceDataContext.Provider, {
    value: providedValue,
    children
  });
};

export { ResourceDataContextProvider };
//# sourceMappingURL=ResourceDataContextProvider.js.map
